import React from "react";
import { getTrivvyVisibilityLabel } from "../data";

// TBV-671: privacy tag shown under a Trivvy title in the lists ("Only Me" /
// "All Admins"). Sits in the same slot the old "Source" tag used. Legacy Trivvys
// with no `visibility` value render as "Only Me".
const TrivvyPrivacyTag = ({ visibility }) => {
  return (
    <div className="item-source-trivvy-list trivvy-privacy-tag">
      {getTrivvyVisibilityLabel(visibility)}
    </div>
  );
};

export default TrivvyPrivacyTag;
